import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function GuidedResponseFlowDebugPathButton(props) {
	const { isLoading, handler } = props;
	const [isClicked, setIsClicked] = useState(false);

	const clicked = (e) => {
		setIsClicked(true);
		handler(e);
	};

	return (
		<button className="btn btn-primary-alt" type="button" onClick={clicked}>
			{isClicked && isLoading ? (
				<span>
					<FontAwesomeIcon icon="spinner" spin /> Processing...
				</span>
			) : (
				<span>Download Debug Path</span>
			)}
		</button>
	);
}
